import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const ArrowCircleRight = (props: SvgIconT.Props) => (
  <SvgIcon width={28} height={28} {...props} viewBox="0 0 28 28">
    <path d="M14 0C6.268 0 0 6.268 0 14s6.268 14 14 14 14-6.268 14-14S21.732 0 14 0Zm0 1c7.18 0 13 5.82 13 13s-5.82 13-13 13S1 21.18 1 14 6.82 1 14 1Zm.38 6.216a1 1 0 0 0-.236 1.302l.072.103L17.684 13H7a1 1 0 0 0-.117 1.993L7 15h10.683l-3.467 4.38a1 1 0 0 0 .07 1.32l.093.084a1 1 0 0 0 1.321-.07l.084-.093L21.025 14l-5.241-6.62a1 1 0 0 0-1.405-.164Z" />
  </SvgIcon>
);

export default ArrowCircleRight;
